import styled from 'styled-components';

export const CreateAndEditContentContainer = styled.div`
    max-width: 1300px;

`;
